import * as React from "react";

// @ts-ignore
import css from "./action-button.module.scss";

interface IActionButtonProps {
    label: string;
    onClick: () => void;
    backgroundColor?: string;
    type?: "normal" | "confirm" | "warning";
}

export const ActionButton: React.FC<IActionButtonProps> = (props) => {
    const { label, onClick, type = "normal", } = props;
    return (
        <button
            data-action-button-type={ type }
            className={ css.button }
            onClick={ onClick }>
            { label }
        </button>
    );
};
